export function decimalToDMS(decimal, isLatitude) {
  const degrees = Math.abs(Math.floor(decimal));
  const minutesWithDecimal = (Math.abs(decimal) - degrees) * 60;
  const minutes = Math.floor(minutesWithDecimal);
  const seconds = (minutesWithDecimal - minutes) * 60;
  const direction = isLatitude ? (decimal >= 0 ? 'N' : 'S') : (decimal >= 0 ? 'E' : 'W');
  return `${degrees}° ${minutes}' ${seconds.toFixed(2)}" ${direction}`;
}

export function decimalToUTM(lat, lng) {
  const a = 6378137;
  const f = 1 / 298.257223563;
  const b = a * (1 - f);
  const e2 = 1 - (b * b) / (a * a);
  const ep2 = e2 / (1 - e2);
  const k0 = 0.9996;

  const latRad = (lat * Math.PI) / 180;
  const lngRad = (lng * Math.PI) / 180;

  const zoneNumber = Math.floor((lng + 180) / 6) + 1;
  const centralMeridianRad = (((zoneNumber - 1) * 6 - 180 + 3) * Math.PI) / 180;

  const N = a / Math.sqrt(1 - e2 * Math.sin(latRad) ** 2);
  const T = Math.tan(latRad) ** 2;
  const C = ep2 * Math.cos(latRad) ** 2;
  const A = Math.cos(latRad) * (lngRad - centralMeridianRad);

  const M = a * (
    (1 - e2 / 4 - (3 * e2 ** 2) / 64 - (5 * e2 ** 3) / 256) * latRad
    - (3 * e2 / 8 + (3 * e2 ** 2) / 32 + (45 * e2 ** 3) / 1024) * Math.sin(2 * latRad)
    + ((15 * e2 ** 2) / 256 + (45 * e2 ** 3) / 1024) * Math.sin(4 * latRad)
    - ((35 * e2 ** 3) / 3072) * Math.sin(6 * latRad)
  );

  const easting = Math.round(
    k0 * N * (A + ((1 - T + C) * A ** 3) / 6 + ((5 - 18 * T + T ** 2 + 72 * C - 58 * ep2) * A ** 5) / 120) + 500000
  );

  let northing = k0 * (
    M + N * Math.tan(latRad) * (
      A ** 2 / 2
      + ((5 - T + 9 * C + 4 * C ** 2) * A ** 4) / 24
      + ((61 - 58 * T + T ** 2 + 600 * C - 330 * ep2) * A ** 6) / 720
    )
  );
  if (lat < 0) northing += 10000000;
  northing = Math.round(northing);

  const latBands = 'CDEFGHJKLMNPQRSTUVWX';
  const bandIndex = Math.min(Math.floor((lat + 80) / 8), 19);
  const latBand = lat >= 84 ? 'X' : lat < -80 ? 'C' : latBands[bandIndex];

  return `${zoneNumber}${latBand} ${easting}E ${northing}N`;
}

export function decimalToUTMParts(lat, lng) {
  const a = 6378137;
  const f = 1 / 298.257223563;
  const b = a * (1 - f);
  const e2 = 1 - (b * b) / (a * a);
  const ep2 = e2 / (1 - e2);
  const k0 = 0.9996;

  const latRad = (lat * Math.PI) / 180;
  const lngRad = (lng * Math.PI) / 180;

  const zoneNumber = Math.floor((lng + 180) / 6) + 1;
  const centralMeridianRad = (((zoneNumber - 1) * 6 - 180 + 3) * Math.PI) / 180;

  const N = a / Math.sqrt(1 - e2 * Math.sin(latRad) ** 2);
  const T = Math.tan(latRad) ** 2;
  const C = ep2 * Math.cos(latRad) ** 2;
  const A = Math.cos(latRad) * (lngRad - centralMeridianRad);

  const M = a * (
    (1 - e2 / 4 - (3 * e2 ** 2) / 64 - (5 * e2 ** 3) / 256) * latRad
    - (3 * e2 / 8 + (3 * e2 ** 2) / 32 + (45 * e2 ** 3) / 1024) * Math.sin(2 * latRad)
    + ((15 * e2 ** 2) / 256 + (45 * e2 ** 3) / 1024) * Math.sin(4 * latRad)
    - ((35 * e2 ** 3) / 3072) * Math.sin(6 * latRad)
  );

  const eastingM = Math.round(
    k0 * N * (A + ((1 - T + C) * A ** 3) / 6 + ((5 - 18 * T + T ** 2 + 72 * C - 58 * ep2) * A ** 5) / 120) + 500000
  );

  let northingM = k0 * (
    M + N * Math.tan(latRad) * (
      A ** 2 / 2
      + ((5 - T + 9 * C + 4 * C ** 2) * A ** 4) / 24
      + ((61 - 58 * T + T ** 2 + 600 * C - 330 * ep2) * A ** 6) / 720
    )
  );
  if (lat < 0) northingM += 10000000;
  northingM = Math.round(northingM);

  const latBands = 'CDEFGHJKLMNPQRSTUVWX';
  const bandIndex = Math.min(Math.floor((lat + 80) / 8), 19);
  const latBand = lat >= 84 ? 'X' : lat < -80 ? 'C' : latBands[bandIndex];

  return {
    zone: `${zoneNumber}${latBand}`,
    eastingM,
    northingM,
    hemisphere: lat >= 0 ? 'N' : 'S',
  };
}

export function getLatLngGeoson(object, type) {
  const jsonObj = object.geoJson ? JSON.parse(object.geoJson) : object
  let value
  if (object.geoJson) {
    if (type == 'latitude') {
      value = jsonObj?.features[0]?.geometry?.coordinates.length != 2 ? jsonObj?.features[0]?.geometry?.coordinates[0][0] : jsonObj?.features[0]?.geometry?.coordinates[0]
    } else if (type == 'longitude') {
      value = jsonObj?.features[0]?.geometry?.coordinates.length != 2 ? jsonObj?.features[0]?.geometry?.coordinates[0][1] : jsonObj?.features[0]?.geometry?.coordinates[1]
    }
  } else {
    if (type == 'latitude') {
      value = object.latitude
    }
    if (type == 'longitude') {
      value = object.longitude
    }
  }

  return value

}

// export let dateConvertion = (date) => {
//   if (date) {
//     const inputDate = date;
//     const dateObject = new Date(inputDate);
//     // Format the date
//     const options = { month: 'numeric', day: 'numeric', year: '2-digit', hour: 'numeric', minute: 'numeric', hour12: true };
//     const formattedDate = dateObject.toLocaleDateString('en-US', options);
//     return formattedDate
//   } else {
//     return
//   }
// }

export const dateConvertion = date => {
  if (date) {
    let displayDate = Date.now()
    displayDate = new Date(displayDate)
    if (date) {
      date.length > 24 ? date = date.slice(0, 24) : null
      displayDate = new Date(date)
    }
    var localOffset = displayDate.getTimezoneOffset() * 60000
    var localTime = displayDate.getTime()
    displayDate = localTime - localOffset
    displayDate = new Date(displayDate)
    const options = { month: 'numeric', day: 'numeric', year: '2-digit', hour: 'numeric', minute: 'numeric', hour12: true };
    let displayDateString = displayDate.toLocaleDateString('en-US', options)
    return displayDateString
  } else {
    return false
  }
}